import React from 'react';
import CustomButton from './CustomButton';

export default React.lazy(() => import('./CustomButton')) as typeof CustomButton;
